import React, { useState } from 'react';
import axios from 'axios'; // 引入 Axios
import baseURL from './manager/apiConfig'; // 引入 API 基本路徑
import './css/login.css';

function Login({ onLogin }) {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleSubmit = (e) => {
    e.preventDefault();

    // 使用 Axios 發送 POST 請求到後端 API
    axios.post(`${baseURL}/userLogin`, {
      username: username,
      password: password
    })
    .then(response => {
        //檢查 response.data 是否有資料
        if (response.data.status === 0) {
            setError('使用者名稱或密碼錯誤');
        } else {
            setError('');
            // 登入成功，執行 onLogin 函數
            onLogin();
            // 清除 localStorage.setItem('username') 內容
            localStorage.removeItem('username');
            // 登入成功，將使用者名稱存儲在 localStorage 中
            localStorage.setItem('username', username);
            // 刷新整個應用程序並重新渲染 index.js
            window.location.reload();
        }
    })
    .catch(error => {
      console.error('登入請求錯誤:', error);
    });
  };

  return (
    <div className="login-form bg-dark wrapper d-flex align-items-center justify-content-center w-100">
      <div className="login">
      <h2 className='mb-3'>E世代</h2>
      {error && <p className="error-message">{error}</p>}
      <form onSubmit={handleSubmit} className='needs-validation'>
        <div className="form-group was-validated mb-2">
          {/* htmlFor 帳號 */}
          <label htmlFor='usernameInput' className='form-label'>使用者名稱:</label>
          <input
            type="text"
            className='form-control'
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            placeholder='測試帳號: abc'
            required
          />
          <div className="invalid-feedback">請輸入使用者名稱</div>
        </div>
        <div className="form-group was-validated mb-2">
          <label htmlFor='password' className='form-label'>密碼:</label>
          <input
            type="password"
            className='form-control'
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder='測試密碼: aaa'
            required
          />
          <div className="invalid-feedback">請輸入密碼</div>
        </div>
        <div className="form-group form-check mb-2">
          <input
            type="checkbox"
            id='rememberMe'
            className='form-check-input'
            onChange={(e) => {
              if (e.target.checked) {
                localStorage.setItem('rememberMe', 'true');
              } else {
                localStorage.removeItem('rememberMe');
              }
            }}
          />
          <label htmlFor='rememberMe' className='form-check-label'>記住我</label>
        </div>
        <button type="submit" className='btn btn-success w-100 mt-2'>登入</button>
      </form>
      </div>
    </div>
  );
}

export default Login;
